/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Referral-entry bonus configuration. When set, each qualified referral (a user who signed up through the referrer's code during the campaign window AND enrolled in this challenge's BrandActivation) grants the referrer perReferralPoints raffle entries, capped at maxReferrals referrals. Entries are computed at read time — surfaced on the my-progression endpoint and added to the Grand Prize entry pool. Unset disables referral bonuses for the challenge.
 * @export
 * @interface ChallengeReferralBonus
 */
export interface ChallengeReferralBonus {
    /**
     * Raffle entries granted to the referrer per qualified referral (e.g. 40).
     * @type {number}
     * @memberof ChallengeReferralBonus
     */
    perReferralPoints: number;
    /**
     * Maximum number of referrals that earn entries per user (e.g. 5).
     * @type {number}
     * @memberof ChallengeReferralBonus
     */
    maxReferrals: number;
}

/**
 * Check if a given object implements the ChallengeReferralBonus interface.
 */
export function instanceOfChallengeReferralBonus(value: object): value is ChallengeReferralBonus {
    if (!('perReferralPoints' in value) || value['perReferralPoints'] === undefined) return false;
    if (!('maxReferrals' in value) || value['maxReferrals'] === undefined) return false;
    return true;
}

export function ChallengeReferralBonusFromJSON(json: any): ChallengeReferralBonus {
    return ChallengeReferralBonusFromJSONTyped(json, false);
}

export function ChallengeReferralBonusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeReferralBonus {
    if (json == null) {
        return json;
    }
    return {
        
        'perReferralPoints': json['perReferralPoints'],
        'maxReferrals': json['maxReferrals'],
    };
}

export function ChallengeReferralBonusToJSON(json: any): ChallengeReferralBonus {
    return ChallengeReferralBonusToJSONTyped(json, false);
}

export function ChallengeReferralBonusToJSONTyped(value?: ChallengeReferralBonus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'perReferralPoints': value['perReferralPoints'],
        'maxReferrals': value['maxReferrals'],
    };
}

